var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVCms01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_1786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8189 15.3304H1.8134C1.18404 15.3304 0.673828 15.8407 0.673828 16.47V26.2204",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.673828 28.8262V30.9078C0.673828 31.5372 1.18404 32.0474 1.8134 32.0474H12.1677",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41091 21.3154C9.57436 21.4284 9.79092 21.4284 9.95437 21.3154C10.2643 21.1014 10.8321 20.8087 11.6201 20.8087C12.7672 20.8087 13.5577 21.6953 13.5577 22.7276C13.5577 23.8933 12.5323 25.2674 9.88536 26.4748C9.75668 26.5335 9.60859 26.5335 9.47992 26.4748C6.83298 25.2674 5.80762 23.8933 5.80762 22.7276C5.80762 21.6952 6.59809 20.8087 7.74513 20.8087C8.53318 20.8087 9.10099 21.1013 9.41091 21.3154Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1546 13.0669L35.6152 8.65601",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2962 6.0499L34.913 2.91576C34.8606 2.48705 34.4705 2.18198 34.0417 2.23437L14.5501 4.61775C14.1213 4.67014 13.8162 5.06021 13.8687 5.48901L16.6163 27.9602",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5137 8.75719L30.2221 7.44788",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0405 13.067L29.0611 11.964",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5674 17.3767L27.3827 16.5433",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0947 21.6864L25.654 21.1289",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6216 25.9961L24.0778 25.6958",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.245 25.9169L45.2663 17.5877C45.4521 17.0757 45.1875 16.51 44.6755 16.3243L30.5083 11.1854C29.9963 10.9996 29.4306 11.2642 29.2449 11.7762L26.4619 19.4484C36.2796 17.8999 34.752 25.1677 42.245 25.9169Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8022 32.2206L38.3158 33.8578C38.8278 34.0436 39.3935 33.779 39.5792 33.267L42.2454 25.9167",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4625 19.4485L23.558 27.4557C23.5267 27.542 23.5082 27.6297 23.5015 27.7169",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0988 20.3771C40.8523 20.3771 41.4632 19.7662 41.4632 19.0127C41.4632 18.2592 40.8523 17.6483 40.0988 17.6483C39.3452 17.6483 38.7344 18.2592 38.7344 19.0127C38.7344 19.7662 39.3452 20.3771 40.0988 20.3771Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2339 35.2808L21.566 32.795C21.0967 32.477 20.4629 32.8132 20.4629 33.38V38.3516C20.4629 38.9184 21.0967 39.2546 21.566 38.9366L25.2339 36.4508C25.6475 36.1705 25.6475 35.5612 25.2339 35.2808Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6363 37.153V29.1109C33.6363 28.4754 33.1211 27.9602 32.4855 27.9602H13.5218C12.8863 27.9602 12.3711 28.4754 12.3711 29.1109V42.6207C12.3711 43.2562 12.8862 43.7715 13.5218 43.7715H32.4855C33.121 43.7715 33.6363 43.2563 33.6363 42.6207V39.7589",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_1786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCms01);
export default __webpack_public_path__ + "static/media/vCMS01.768b7d8d01c97b6e56b39fbf35bfbd1e.svg";
export { ForwardRef as ReactComponent };